import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import AlertDialog from '../../../common/components/dialog/alert-dialog';




const styles = theme => ({
    contentsTitleWrap:{
        position:'absolute',
        top:30,
        left:0,
        width:'100%',
        zIndex:1
    },
    contentTitle:{
        color:'#FFFFFF',
        textAlign:'center'
    },
    contentSupportTextIcon:{
        verticalAlign:'top',
        marginRight: 5
    },
    button: {
        margin: theme.spacing.unit,
        display:'inline-block',
        color:"#FFFFFF"
    },
    closeIcon:{
        position:'absolute',
        top:10,
        right:10,
        zIndex:3
    },
    agreeArea:{
        position:'absolute',
        bottom:50,
        left:0,
        width:'100%',
        textAlign:'center'
    },
    agreeCheckLabel:{
        color:'#FFFFFF'
    }


});

const WhiteCheckbox = withStyles({
    root: {
        color: "#FFFFFF",
        '&$checked': {
            color: "#FFFFFF",
        },
    },
    checked: {},
})(props => <Checkbox color="default" {...props} />);

class Viewer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            agree : false,
            closeDialogOpen : false,
        };
    }

    handleChangeAgreeCheck = () =>{
        this.setState({
            agree : !this.state.agree
        });
    };


    handleClickClose = () =>{
        this.setState({
            closeDialogOpen:true
        });
    };

    handleCancelClose = () =>{
        this.setState({
            closeDialogOpen:false
        });
    };

    handleClose = () => {
        this.setState({
            closeDialogOpen:false
        });
        if(this.props.afterCloseFunc) this.props.afterCloseFunc();
    };

    handleClickOk = () =>{
        this.setState({
            agree:false
        });
        if(this.props.afterOkFunc) this.props.afterOkFunc();
    };



    render() {
        const {agree} = this.state;
        const {classes, filePath} = this.props;
        const height = (this.props.navigation.windowHeight * 0.95) - 250;
        const width = (this.props.navigation.windowWidth * 0.9) - 60;
        return (

            <div className="over_rays">


                <div className={classes.contentsTitleWrap}>
                    <p className={classes.contentTitle}>
                        telesa-deliveryのご利用には「利用規約」の同意が必要です。<br />
                        以下の内容をご確認の上、ご同意いただける場合にのみ<br />
                        「利用規約に同意する」にチェックを入れ、OKボタンをクリックし次へお進みください
                    </p>
                </div>
                <div className={classes.closeIcon}>
                    <IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
                                onClick={this.handleClickClose}>
                        <CloseIcon/>
                    </IconButton>
                </div>
                <div className="pdf_inner">
                    <embed
                        src={filePath}
                        width={width}
                        height={height}
                    />
                </div>

                <div className={classes.agreeArea}>
                    <FormControlLabel
                        control={
                            <WhiteCheckbox
                                checked={agree}
                                onChange={this.handleChangeAgreeCheck}
                                value="checkedB"
                                color="primary"
                                name="auto_login"
                            />
                        }
                        label={<span style={{color:"#FFFFFF"}}>利用規約に同意する</span>}
                    />
                    <br/>
                    <Button variant="contained" color="primary" disabled={!agree} onClick={this.handleClickOk}>
                        OK
                    </Button>
                </div>
                <AlertDialog
                    open={this.state.closeDialogOpen}
                    title={"ご注意ください"}
                    text={<span>利用規約への同意がない場合、<br />当サービスはご利用になれません</span>}
                    okFunction={this.handleClose}
                    closeFunction={this.handleCancelClose}
                />
            </div>

        );
    }
}
Viewer.propTypes = {
    filePath:PropTypes.string,
    afterCloseFunc:PropTypes.func,
    afterOkFunc:PropTypes.func,
};
function mapStateToProps(state) {
    return {
        navigation : state.navigation
    };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(Viewer);


// WEBPACK FOOTER //
// ./src/routes/menu/components/viewer.js